export default {
  name: 'fw-selection-button',
  fragment: {
      template: '<div class="fwSelectionButtonBox"><div><xbutton  @controller="states:SelectTextImageController" name="fw-selection-text-annotation" @tooltip icon-class="fv__icon-toolbar-select"></xbutton></div></div>',
      config: [{
          target: 'fw-selection-text-annotation',
          attrs: {
              'tooltip-title': 'toolbar.tooltip.select.title'
          }
      }]
  }
};